import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-flagged-user',
  templateUrl: './flagged-user.component.html',
  styleUrls: ['./flagged-user.component.scss']
})
export class FlaggedUserComponent implements OnInit {
  @Input() flagged!: boolean;
  @Input() flagNotes?: string[];

  constructor() { }

  ngOnInit(): void {
  }

}
